import { Slot } from '@radix-ui/react-slot';
import cn from '@utils/cn';
import { cva, type VariantProps } from 'class-variance-authority';
import { ButtonHTMLAttributes } from 'react';

const buttonVariants = cva(
  'ring-offset-background inline-flex items-center justify-center rounded-full focus-visible:ring-transparent ' +
    'transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2 ' +
    'font-the-future whitespace-nowrap font-medium  disabled:opacity-50 cursor-pointer',
  {
    variants: {
      variant: {
        primary: 'bg-primary-no-alpha text-primary-foreground border hover:opacity-80',
        outline: 'text-foreground hover:bg-input border',
        secondary: 'bg-secondary-no-alpha text-secondary-foreground hover:opacity-80',
        link: 'text-link font-the-future p-0 hover:underline hover:underline-offset-4',
      },
      size: {
        xl: 'text-base-medium w-full px-[24px] py-[14px] sm:w-auto',
        l: 'text-sm-medium w-full px-[20px] py-[10px] sm:w-auto',
        m: 'text-sm-medium px-[16px] py-[6px]',
        s: 'text-xs-medium px-[16px] py-[6px]',
        xs: 'text-xs-medium px-[12px] py-[4px]',
        icon: 'h-10 w-10',
        link: '',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'l',
    },
  },
);

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof buttonVariants> {
  asChild?: boolean;
}

function Button({ className, variant, size, asChild = false, ...props }: ButtonProps) {
  const Comp = asChild ? Slot : 'button';
  return <Comp className={cn(buttonVariants({ variant, size }), className)} {...props} />;
}

export { Button, buttonVariants };
